import { createSelector } from "reselect"
import { find, chain, isFinite, pick, remove } from "lodash"
import { computeData } from "modules/analyze-risk/selectors/data"
import { getAllCategoryItems, isSegmentFilter } from "modules/analyze-risk/selectors/items"
import { getRisk } from "modules/analyze-risk/selectors/risk"
import { computeSelectedValue, getLastContributor } from "helpers/contributors"

const getSelectedDate = (state, props) => props.selectedDate
const getSelectedRaw = state => state.modules.analyzeRiskDetails.selected
const getShowSegment = (state, props) => props.showSegment

const getContributorData = createSelector(
  [getAllCategoryItems, getRisk],
  (items, risk) => computeData(items, risk),
)

export const getSelected = createSelector(
  [getSelectedRaw, getAllCategoryItems, getShowSegment],
  (selected, items, showSegment) => {
    if (!selected) {
      return selected
    }

    const found = find(items, d => d.id === selected.id)
    if (found && (!showSegment || (showSegment && selected.id !== "total"))) {
      return selected
    }
    return null
  },
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getShowSegment],
  (data, date, items, showSegment) => {
    const lastContributor = getLastContributor(data, date) || {}

    const rows = chain(items)
      .map(item => ({
        ...pick(item, ["label", "categoryLabel", "id", "color", "favorite", "field", "isAggregated"]),
        value: lastContributor[item.id],
      }))
      .filter(item => isFinite(item.value) || item.favorite)
      .value()
    if (!showSegment) {
      remove(rows, isSegmentFilter)
      return rows
    }

    return rows
  },
)

export const getSelectedValue = createSelector(
  [getDetails, getSelected],
  computeSelectedValue,
)
